export default class Clock {
  constructor(refreshRate = 1000) {
    this.refreshRate = refreshRate;
    this.stopped = true;

    Object.defineProperties(this, {
      intervalId: {
        writable: true,
        configurable: false,
        value: null,
      },
    });

    this.refresh();
  }

  refresh() {
    this.now = new Date();
  }

  start() {
    if (!this.stopped) return;

    this.intervalId = setInterval(this.refresh.bind(this), this.refreshRate);
    this.refresh();

    this.stopped = false;
  }

  stop() {
    if (this.stopped) return;

    clearInterval(this.intervalId);

    this.stopped = true;
  }
}
